const LeadBusinessTypeData = [
  {
    value: "trader",
    label: "Trader",
  },

  {
    value: "distributor",
    label: "Distributor",
  },
  {
    value: "retailer",
    label: "Retailer",
  },
  {
    value: "end_user",
    label: "End User",
  },
];

const CustomerBusinessTypeData = [
  {
    value: "proprietor",
    label: "Proprietor",
  },

  {
    value: "pvt_ltd",
    label: "Private Limited",
  },
  {
    value: "partnership",
    label: "Partnership",
  },
  {
    value: "limited",
    label: "Limited",
  },
];

const StateOption = [
  {
    id: 1,
    value: "Andhra Pradesh",
    label: "Andhra Pradesh",
  },

  {
    id: 2,
    value: "Arunachal Pradesh",
    label: "Arunachal Pradesh",
  },
  {
    id: 3,
    value: "Assam",
    label: "Assam",
  },
  {
    id: 4,
    value: "Bihar",
    label: "Bihar",
  },
  {
    id: 5,
    value: "Chhattisgarh",
    label: "Chhattisgarh",
  },
  {
    id: 6,
    value: "Goa",
    label: "Goa",
  },
  {
    id: 7,
    value: "Gujarat",
    label: "Gujarat",
  },
  {
    id: 8,
    value: "Haryana",
    label: "Haryana",
  },
  {
    id: 9,
    value: "Himachal Pradesh",
    label: "Himachal Pradesh",
  },
  {
    id: 10,
    value: "Jharkhand",
    label: "Jharkhand",
  },
  {
    id: 11,
    value: "Karnataka",
    label: "Karnataka",
  },
  {
    id: 12,
    value: "Kerala",
    label: "Kerala",
  },
  {
    id: 13,
    value: "Madhya Pradesh",
    label: "Madhya Pradesh",
  },
  {
    id: 14,
    value: "Maharashtra",
    label: "Maharashtra",
  },
  {
    id: 15,
    value: "Manipur",
    label: "Manipur",
  },
  {
    id: 16,
    value: "Meghalaya",
    label: "Meghalaya",
  },
  {
    id: 17,
    value: "Mizoram",
    label: "Mizoram",
  },
  {
    id: 18,
    value: "Nagaland",
    label: "Nagaland",
  },
  {
    id: 19,
    value: "Odisha",
    label: "Odisha",
  },
  {
    id: 20,
    value: "Punjab",
    label: "Punjab",
  },
  {
    id: 21,
    value: "Rajasthan",
    label: "Rajasthan",
  },
  {
    id: 22,
    value: "Sikkim",
    label: "Sikkim",
  },
  {
    id: 23,
    value: "Tamil Nadu",
    label: "Tamil Nadu",
  },
  {
    id: 24,
    value: "Telangana",
    label: "Telangana",
  },
  {
    id: 25,
    value: "Tripura",
    label: "Tripura",
  },
  {
    id: 26,
    value: "Uttar Pradesh",
    label: "Uttar Pradesh",
  },
  {
    id: 27,
    value: "Uttarakhand",
    label: "Uttarakhand",
  },
  {
    id: 28,
    value: "West Bengal",
    label: "West Bengal",
  },
  {
    id: 28,
    value: "New Delhi",
    label: "New Delhi",
  },
  {
    id: 29,
    value: "Jammu & Kashmir",
    label: "Jammu & Kashmir",
  },
  {
    id: 30,
    value: "Ladakh",
    label: "Ladakh",
  },
];

const DistributionTypeOption = [
  {
    id: 1,
    value: "Wholeseller",
    label: "Wholeseller",
  },

  {
    id: 2,
    value: "Retailer",
    label: "Retailer",
  },
];

const CategoryOption = [
  { id: 1, label: "Hardware", value: "Hardware" },
  { id: 2, label: "Plywood", value: "Plywood" },
  { id: 3, label: "Plumbing", value: "Plumbing" },
  { id: 4, label: "After Auto", value: "After Auto" },
  { id: 5, label: "Stationery", value: "Stationery" },
  { id: 6, label: "Electricals", value: "Electricals" },
  { id: 7, label: "Paints", value: "Paints" },
  { id: 8, label: "Submersible Pumps", value: "Submersible Pumps" },
  { id: 9, label: "Industrial Distributor", value: "Industrial Distributor" },
  { id: 10, label: "Home Décor", value: "Home Décor" },
  { id: 11, label: "Pop & False Ceiling", value: "Pop & False Ceiling" },
  { id: 12, label: "Glass Hardware", value: "Glass Hardware" },
  {
    id: 13,
    label: "Aluminium Hardware & Section",
    value: "Aluminium Hardware & Section",
  },
  { id: 14, label: "Signage", value: "Signage" },
  { id: 25, label: "MRO", value: "mro" },
];

const IndustriesList = [
  { id: 1, label: "Automotive", value: "automotive" },
  { id: 2, label: "Construction", value: "construction" },
  { id: 3, label: "Electronic", value: "electronic" },
  { id: 4, label: "Paper", value: "paper" },
  { id: 5, label: "Print", value: "print" },
  { id: 6, label: "Renewable Energies", value: "renewable_energies" },
  { id: 7, label: "Food Industry", value: "food_industry" },
  { id: 8, label: "Laminates", value: "laminates" },
  { id: 9, label: "Bus Body", value: "bus_body" },
  { id: 10, label: "Wireharness", value: "wireharness" },
  { id: 11, label: "Appliance", value: "appliance" },
  { id: 12, label: "Flexible Packaging", value: "flexible_packaging" },
  { id: 13, label: "Leather", value: "leather" },
  { id: 14, label: "Shoes", value: "shoes" },
  { id: 15, label: "Soft Luggage", value: "soft_luggage" },
  { id: 16, label: "Telecom", value: "telecom" },
  { id: 17, label: "Power Cables", value: "power_cables" },
  { id: 18, label: "Signage", value: "signage" },
  { id: 19, label: "LED Lightings", value: "led_lightings" },
  { id: 20, label: "Adhesive Tape", value: "adhesive_tape" },
  { id: 21, label: "OEM (White Label)", value: "oem_white_label" },
  { id: 22, label: "Optical Lens", value: "optical_lens" },
];

const businessMismatchsOption = [
  {
    value: "yes",
    label: "Yes",
  },

  {
    value: "no",
    label: "No",
  },
];

const interestOption = [
  {
    value: "yes",
    label: "Yes",
  },

  {
    value: "no",
    label: "No",
  },
];

const MainDistribution = [
  { id: 1, label: "3M", value: "3M" },
  { id: 2, label: "Achem - Taiwan", value: "Achem - Taiwan" },
  { id: 3, label: "Aero", value: "Aero" },
  { id: 4, label: "AIPL ABRO", value: "AIPL ABRO" },
  { id: 5, label: "Airot", value: "Airot" },
  {
    id: 6,
    label: "Ajit Industries / AIPL / Sunsui",
    value: "Ajit Industries / AIPL / Sunsui",
  },
  { id: 7, label: "Amech Wonder", value: "Amech Wonder" },
  { id: 8, label: "Amro Wonder", value: "Amro Wonder" },
  { id: 9, label: "Anchor Electricals", value: "Anchor Electricals" },
  { id: 10, label: "ANNA - Drywall Tape", value: "ANNA - Drywall Tape" },
  { id: 11, label: "Arjun - Spray Paint", value: "Arjun - Spray Paint" },
  { id: 12, label: "ASD - Spray Paint", value: "ASD - Spray Paint" },
  { id: 13, label: "Asian Paints", value: "Asian Paints" },
  { id: 14, label: "Banna - Spray Paints", value: "Banna - Spray Paints" },
  { id: 15, label: "Berger Paints", value: "Berger Paints" },
  { id: 16, label: "Biocon Electricals", value: "Biocon Electricals" },
  { id: 17, label: "Bosny - Spray Paints", value: "Bosny - Spray Paints" },
  { id: 18, label: "Champion - PTFE Tape", value: "Champion - PTFE Tape" },
  { id: 19, label: "Cobb - Spray Paint", value: "Cobb - Spray Paint" },
  { id: 20, label: "Cooper - PTFE Tape", value: "Cooper - PTFE Tape" },
  { id: 21, label: "Cosmos - Spray Paints", value: "Cosmos - Spray Paints" },
  { id: 22, label: "CQL - Spray Paints", value: "CQL - Spray Paints" },
  {
    id: 23,
    label: "Craft Dev - Spray Paints",
    value: "Craft Dev - Spray Paints",
  },
  { id: 24, label: "Cube - Spray Paints", value: "Cube - Spray Paints" },
  { id: 25, label: "Diamond - PTFE Tape", value: "Diamond - PTFE Tape" },
  { id: 26, label: "Dinmo - Spray Paints", value: "Dinmo - Spray Paints" },
  { id: 27, label: "Dornet - Drywall Tape", value: "Dornet - Drywall Tape" },
  {
    id: 28,
    label: "Espark Wonder / Maruti Flex",
    value: "Espark Wonder / Maruti Flex",
  },
  { id: 29, label: "Essence Tapes", value: "Essence Tapes" },
  { id: 30, label: "Euro Tapes", value: "Euro Tapes" },
  { id: 31, label: "F1 - Spray Paints", value: "F1 - Spray Paints" },
  { id: 32, label: "G2 - Electricals", value: "G2 - Electricals" },
  { id: 33, label: "GM Electricals", value: "GM Electricals" },
  {
    id: 34,
    label: "Gomec Industries / Accent Wonder",
    value: "Gomec Industries / Accent Wonder",
  },
  { id: 35, label: "Great White", value: "Great White" },
  {
    id: 36,
    label: "Gree / Rajguru Adhesive Tapes",
    value: "Gree / Rajguru Adhesive Tapes",
  },
  { id: 37, label: "Gripking Tapes", value: "Gripking Tapes" },
  { id: 38, label: "Gypstar - Drywall Tape", value: "Gypstar - Drywall Tape" },
  { id: 39, label: "Gyptech - Drywall Tape", value: "Gyptech - Drywall Tape" },
  { id: 40, label: "Immortal Tapes", value: "Immortal Tapes" },
  { id: 41, label: "Instabiz / I-Stix", value: "Instabiz / I-Stix" },
  { id: 42, label: "I-tape", value: "I-tape" },
  { id: 43, label: "Kansuee Industries", value: "Kansuee Industries" },
  {
    id: 44,
    label: "Keval Industries - Tissue",
    value: "Keval Industries - Tissue",
  },
  { id: 45, label: "Kobe - Spray Paint", value: "Kobe - Spray Paint" },
  { id: 46, label: "Kohinoor - PTFE Tape", value: "Kohinoor - PTFE Tape" },
  {
    id: 47,
    label: "Kotadia Engineering / SHB",
    value: "Kotadia Engineering / SHB",
  },
  { id: 48, label: "k-rock", value: "k-rock" },
  { id: 49, label: "Lohmann Tapes", value: "Lohmann Tapes" },
  { id: 50, label: "Mario Industries", value: "Mario Industries" },
  { id: 51, label: "Mexico Wonder", value: "Mexico Wonder" },
  { id: 52, label: "Mexim Adhesive", value: "Mexim Adhesive" },
  { id: 53, label: "MNM Composites", value: "MNM Composites" },
  { id: 54, label: "Mseal", value: "Mseal" },
  { id: 55, label: "MST - Spray Paint", value: "MST - Spray Paint" },
  { id: 56, label: "Nitto - AFT", value: "Nitto - AFT" },
  { id: 57, label: "Oddy / Atul", value: "Oddy / Atul" },
  { id: 58, label: "One Tape", value: "One Tape" },
  { id: 59, label: "Panamax / THB", value: "Panamax / THB" },
  { id: 60, label: "Pidilite / SteelGrip", value: "Pidilite / SteelGrip" },
  { id: 61, label: "pioneer spray paint", value: "pioneer spray paint" },
  { id: 62, label: "Reva Gold", value: "Reva Gold" },
  { id: 63, label: "Saint Gobain - Gyproc", value: "Saint Gobain - Gyproc" },
  { id: 64, label: "Sampro - Spray Paint", value: "Sampro - Spray Paint" },
  {
    id: 65,
    label: "Samraj Polytex - 4S Spray",
    value: "Samraj Polytex - 4S Spray",
  },
  { id: 66, label: "Samurai - Spray Paint", value: "Samurai - Spray Paint" },
  { id: 67, label: "Saraswat / AFT", value: "Saraswat / AFT" },
  { id: 68, label: "Selmex Tapes", value: "Selmex Tapes" },
  { id: 69, label: "Signfix / AFT", value: "Signfix / AFT" },
  { id: 70, label: "Specialty Tapes", value: "Specialty Tapes" },
  { id: 71, label: "Sumax", value: "Sumax" },
  { id: 72, label: "Tesa Tapes", value: "Tesa Tapes" },
  {
    id: 73,
    label: "Touch Up - Spray Paints",
    value: "Touch Up - Spray Paints",
  },
  {
    id: 74,
    label: "Twin Tech - Spray Paint",
    value: "Twin Tech - Spray Paint",
  },
  { id: 75, label: "UCS - Drywall Tape", value: "UCS - Drywall Tape" },
  { id: 76, label: "USG - Drywall Tape", value: "USG - Drywall Tape" },
  {
    id: 77,
    label: "Vardhaman / Tiger Wonder",
    value: "Vardhaman / Tiger Wonder",
  },
  { id: 78, label: "Vista -  Spray Paint", value: "Vista -  Spray Paint" },
  { id: 79, label: "VST - Spray Paint", value: "VST - Spray Paint" },
];

const ALLOWED_ROLES = [
  "Sales Manager",
  "Sales Deputy Manager",
  "Sales Assistant Deputy Manager",
  "Sales Executive",
  "Sales Manager without Leads",
  "Customer Service",
];

const Marital_Status_Options = ["Married", "UnMarried"];

const Marridal_Status = ["Mr.", "Mrs."];
const UnMarried_Status = ["Mr.", "Ms."];

const religionsInIndia = [
  "Hinduism",
  "Islam",
  "Christianity",
  "Sikhism",
  "Buddhism",
  "Jainism",
  "Zoroastrianism",
  "Judaism",
  "Bahá'í Faith",
  "Animism",
  "Tribal Religions",
  "Sanamahism",
  "Sarnaism",
  "Donyi-Polo",
  "Ravidassia",
  "Ahmadiyya",
  "Shia Islam",
  "Sunni Islam",
  "Roman Catholicism",
  "Protestantism",
  "Orthodox Christianity",
  "Others",
];

const CustomerStatusData = ["Active", "Closed", "Blacklist"];

const Option = {
  LeadBusinessTypeData,
  CustomerBusinessTypeData,
  StateOption,
  DistributionTypeOption,
  CategoryOption,
  IndustriesList,
  businessMismatchsOption,
  interestOption,
  MainDistribution,
  ALLOWED_ROLES,
  Marital_Status_Options,
  religionsInIndia,
  CustomerStatusData,
  Marridal_Status,
  UnMarried_Status,
};
export default Option;
